import React from 'react'
import { Button, Menu } from '@CommonComponents/buttons'

// Kebab (three-dots) menu shown on ToC rows when author tools are enabled.
// Renders a list of actions: [{key, label, icon, onSelect}] in the registry
// Menu, which portals, places and dismisses the surface.
export const TocRowMenu = ({ title, actions }) => (
  // keep arrows/enter/escape from triggering the ToC-wide menu navigation;
  // the portaled surface's events still bubble here through React
  <span className="toc-row-menu" onKeyDown={event => event.stopPropagation()}>
    <Menu
      iconOnly
      label={`Options for ${title}`}
      icon="fa-regular fa-ellipsis-vertical"
      className="me-btn-icon me-btn-icon-xs me-btn-icon-neutral toc-row-menu-btn"
      align="end"
    >
      {actions.map(action =>
        action.divider ? (
          <div key={action.key} className="me-menu-sep" role="separator" />
        ) : (
          <Button
            key={action.key}
            className={`me-menu-item${action.danger ? ' is-danger' : ''}`}
            icon={`${action.icon} me-menu-ico`}
            onClick={action.onSelect}
          >
            {action.label}
          </Button>
        )
      )}
    </Menu>
  </span>
)

// Builds the contextual action list for a ToC row.
// Third-level items only render in the ToC when nested under a level-2
// <chapter>, so "add inside" is only offered where the result will show up.
// Labels follow the tag the server will actually create (see add_toc_item):
// a sibling matches this row's tag, and a child matches the row's existing
// children - WGU-style books nest chapters where classic books hold sections.
export function tocMenuActions({ tag, childTag, depth, itemId, title, onAddItem, onStartRename, onStartDelete, }) {
  const actions = []
  const noun = t => (t === 'chapter' ? 'chapter' : 'section')
  if (depth === 1) {
    actions.push({
      key: 'add-after',
      label: 'Add chapter below',
      icon: 'fa-regular fa-plus',
      onSelect: () => onAddItem(itemId, 'after'),
    })
    actions.push({
      key: 'add-inside',
      label: `Add ${noun(childTag)} inside`,
      icon: 'fa-regular fa-indent',
      onSelect: () => onAddItem(itemId, 'inside'),
    })
  } else {
    actions.push({
      key: 'add-after',
      label: `Add ${noun(tag)} below`,
      icon: 'fa-regular fa-plus',
      onSelect: () => onAddItem(itemId, 'after'),
    })
    if (depth === 2 && tag === 'chapter') {
      actions.push({
        key: 'add-inside',
        label: 'Add section inside',
        icon: 'fa-regular fa-indent',
        onSelect: () => onAddItem(itemId, 'inside'),
      })
    }
  }
  actions.push({
    key: 'rename',
    label: 'Rename',
    icon: 'fa-regular fa-pen',
    onSelect: () => onStartRename(itemId),
  })
  actions.push({ key: 'divider', divider: true })
  actions.push({
    key: 'delete',
    label: 'Delete',
    icon: 'fa-regular fa-trash',
    danger: true,
    onSelect: () => onStartDelete(itemId, title),
  })
  return actions
}
